/**
 *  Copyright (c) 2026 TechDivision GmbH
 *  All rights reserved
 *
 *  This product includes proprietary software developed at TechDivision GmbH, Germany
 *  For more information see https://www.techdivision.com/
 *
 *  To obtain a valid license for using this software please contact us at
 *  license@techdivision.com
 *
 */

/* faq.js
   FAQ section – client-side live search that filters the questions while typing
   (matches question + answer text via data-search-text). */

export function initFaq() {
  var roots = document.querySelectorAll('[data-faq]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var searchInput = root.querySelector('[data-faq-search]');
    if (!searchInput) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var emptyMessage = root.querySelector('[data-faq-empty]');

    function filter(query) {
      var term = query.trim().toLowerCase();
      var visible = 0;

      items.forEach(function (item) {
        var haystack = item.getAttribute('data-search-text') || '';
        var match = term === '' || haystack.indexOf(term) !== -1;
        item.hidden = !match;
        // collapse a matched item again when the search is cleared
        if (term === '') item.open = false;
        if (match) visible++;
      });

      if (emptyMessage) emptyMessage.hidden = visible !== 0;
    }

    searchInput.addEventListener('input', function () {
      filter(searchInput.value);
    });
  });
}

// loaded as a module script by the section that needs it (see
// snippets/module-script.liquid), so the module initialises itself. module
// scripts are deferred, which means the DOM is complete at this point
initFaq();
